import * as React from "react";
import {
  OkHiInlineToPortalMessage,
  useOkHiMessageReceiver,
} from "../hooks/useOkHiMessageReceiver";

const OkHiInlineToPortalMessageContext =
  React.createContext<OkHiInlineToPortalMessage | null>(null);

interface Props {
  children: React.ReactNode;
}

export function OkHiIncomingMessageProvider({ children }: Props) {
  const message = useOkHiMessageReceiver();
  return (
    <OkHiInlineToPortalMessageContext.Provider value={message}>
      {children}
    </OkHiInlineToPortalMessageContext.Provider>
  );
}

export function useOkHiIncomingMessage() {
  const message = React.useContext(OkHiInlineToPortalMessageContext);
  return message?.payload;
}
